export default "__VITE_ASSET__4d1b7958__"